import React, { forwardRef } from 'react';
import { classNames } from '../../utils/format';

const Select = forwardRef(function Select({ options, placeholder, className, invalid, children, ...rest }, ref) {
  return (
    <select
      ref={ref}
      className={classNames('form-control form-select', invalid && 'is-invalid', className)}
      {...rest}
    >
      {placeholder && <option value="">{placeholder}</option>}
      {options
        ? options.map((opt) =>
            typeof opt === 'string' ? (
              <option key={opt} value={opt}>{opt}</option>
            ) : (
              <option key={opt.value} value={opt.value} disabled={opt.disabled}>{opt.label}</option>
            )
          )
        : children}
    </select>
  );
});

export default Select;
